/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import React from "react";
import { AdminLandingPage } from "@vlinder-web/admin-landing-page-widget-react";

import { StateOSD } from "@vlinder-web/state-osd-v2-widget-react";

import { useTheme } from "../../../providers/theme";
import { useSMLandingPage } from "../machines";
import { VApplication } from "../../../application";
import { LandingPageService } from "../../../services";

const getSrv = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.LandingPageService") as LandingPageService;
};

export const ContainerComm = (props: any) => {
  const theme = useTheme();
  const { landingPageMachine, landingPageState, landingPageSend } =
    useSMLandingPage({});
  const staticPageContentConfig = getSrv()?.getStaticPageContent();

  const _renderPage = () => {
    if (landingPageState?.matches("RENDER_PAGE")) {
      return (
        <AdminLandingPage {...(landingPageState?.event?.data?.value || {})} />
      );
    }
    if (landingPageState?.matches("GET_PAGE_CONTENT")) {
      return (
        <StateOSD {...(staticPageContentConfig?.loading?.pageContent || {})} />
      );
    }
    return null;
  };
  return <>{_renderPage()}</>;
};
